import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { CapabilitiesProvider } from "@/lib/capabilities";
import Shell from "@/components/layout/Shell";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Workspaces from "@/pages/Workspaces";
import WorkspaceDetail from "@/pages/WorkspaceDetail";
import Compare from "@/pages/Compare";
import Authorization from "@/pages/Authorization";
import SU24 from "@/pages/SU24";
import OData from "@/pages/OData";
import KnowledgeGraph from "@/pages/KnowledgeGraph";
import Findings from "@/pages/Findings";
import Recommendations from "@/pages/Recommendations";
import Risk from "@/pages/Risk";
import Compliance from "@/pages/Compliance";
import CleanCore from "@/pages/CleanCore";
import Diagnostics from "@/pages/Diagnostics";
import Ueba from "@/pages/Ueba";
import Reports from "@/pages/Reports";
import Admin from "@/pages/Admin";
import Settings from "@/pages/Settings";
import About from "@/pages/About";
import Share from "@/pages/Share";
import RoleEngineering from "@/pages/RoleEngineering";
import InstantAnalysis from "@/pages/InstantAnalysis";
import GovernanceMap from "@/pages/GovernanceMap";
import MitigationLibrary from "@/pages/MitigationLibrary";
import Documentation from "@/pages/Documentation";
import ShareRedirect from "@/pages/ShareRedirect";
import RoleGate from "@/components/common/RoleGate";
import RulesetConfig from "@/pages/RulesetConfig";
import PostureDigest from "@/pages/PostureDigest";
import Utsav from "@/pages/Utsav";
import CodeReview from "@/pages/CodeReview";
import { ModuleGate } from "@/components/common/ModuleGate";

export default function App() {
    return (
        <ThemeProvider>
        <AuthProvider>
            <CapabilitiesProvider>
                <BrowserRouter>
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#12121A",
                            border: "1px solid rgba(0,240,255,0.25)",
                            color: "#F2F6FB",
                            fontFamily: "IBM Plex Sans, sans-serif",
                        },
                    }}
                />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/s/:code" element={<ShareRedirect />} />
                    <Route element={<Shell />}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/workspaces" element={<Workspaces />} />
                        <Route path="/workspaces/:id" element={<WorkspaceDetail />} />
                        <Route path="/compare" element={<Compare />} />
                        <Route path="/authorization" element={<RoleGate require="can_authorization" label="Authorization"><Authorization /></RoleGate>} />
                        <Route path="/su24" element={<RoleGate require="can_su24" label="SU24"><SU24 /></RoleGate>} />
                        <Route path="/odata" element={<RoleGate require="can_odata" label="OData"><OData /></RoleGate>} />
                        <Route path="/graph" element={<KnowledgeGraph />} />
                        <Route path="/findings" element={<Findings />} />
                        <Route path="/recommendations" element={<Recommendations />} />
                        <Route path="/risk" element={<Risk />} />
                        <Route path="/compliance" element={<Compliance />} />
                        <Route path="/clean-core" element={<CleanCore />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/share" element={<Share />} />
                        <Route path="/roles" element={<RoleEngineering />} />
                        <Route path="/instant-analysis" element={<InstantAnalysis />} />
                        <Route path="/governance/map" element={<GovernanceMap />} />
                        <Route path="/governance/mitigation-library" element={<MitigationLibrary />} />
                        <Route path="/docs" element={<Documentation />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/admin/ruleset" element={<RulesetConfig />} />
                        <Route path="/admin/digest" element={<PostureDigest />} />
                        <Route path="/code-review" element={<ModuleGate module="code_review" label="Code Review / RICEFW Security Clearance"><CodeReview /></ModuleGate>} />
                        <Route path="/diagnostics" element={<Diagnostics />} />
                        <Route path="/ueba" element={<Ueba />} />
                        <Route path="/utsav" element={<Utsav />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                </BrowserRouter>
            </CapabilitiesProvider>
        </AuthProvider>
        </ThemeProvider>
    );
}
